export default __webpack_public_path__ + "static/media/aqua_inf.b56368cf.png";